import { Backdrop, CircularProgress, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

const LoadingBackdrop = ({ open, title, messages = ['Carregando'], textChangeRatio = 4500 }) => {
  const [loadingTextIndex, setLoadingTextIndex] = useState(0)
  
  useEffect(() => {
    if (open) {
      setLoadingTextIndex(0)
    }
  }, [open])

  useEffect(() => {
    const intervalID = setInterval(() => {
      setLoadingTextIndex(loadingTextIndex + 1)
    }, textChangeRatio)

    return () => clearInterval(intervalID)
  }, [loadingTextIndex])

  return (
    <Backdrop
      open={open}
      style={{ flexDirection: 'column',  gap: 2, opacity: 0.8, backgroundColor: 'black', color: '#eee' }}
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <h3>Por favor, aguarde</h3>
      <Typography>{title}</Typography>
      <CircularProgress color="inherit" />
      <div>
        <Typography>{messages[Math.min(loadingTextIndex, messages.length - 1)]}</Typography>
      </div>
    </Backdrop>
  )
}

export default LoadingBackdrop
